export default "__VITE_ASSET__BYHSUEiv__"